/* eslint-disable*/
import React, { useState, useEffect } from 'react'
import { handleControl } from './control'
import { renderLabelString } from '@/utils/renderUtils'
import { getProjectBtType } from '@/utils/helpers'
import { SelectC, CascaderC } from '@/i2antdV5'

const I2ProjectBtControl = (props) => {
  const {
      propsClassName, propsClassSpan, style,// 样式 className
      modalProps, label, radio,// 组件 功能参数
      options, query, value, searchKey, // 组件 数据源
      concatData, // 组件 数据源有 3个 1.年份 2.业务类型（旧）3.业务类型
      clearKey, killPending, reduxObj,// 请求相关控制数据
      action, actionChange, resAction, headerchange // 请求方法
    } = props

  //     1.年份 2.业务类型（旧）3.业务类型
  const [ yearObj, btObj, btV2Obj ] = concatData
  // 根据年份变化，更新记录 业务类型状态

  const [ useValue, setUseValue ] = useState({ btDataType: [], year: '' })
  useEffect(() => {
    const findYear = yearObj.options.find(item => item.id === query[yearObj.searchKey]) || {}
      const getbtDataType = getProjectBtType(findYear.value)
      setUseValue({
        ...useValue,
        btDataType: getbtDataType
      })
  }, [query.refQ, query[yearObj.searchKey]])
  // 对应渲染 业务类型 组件
  // 把对应数据 传入组件， 这里不做数据处理


  const onYearChange = (e, option) => { 
    setUseValue({
      ...useValue,
      year: option.children
    })
  }
  // console.log('yearObj', yearObj, 'btObj', btObj, 'btV2Ob', btV2Obj)
  const renderBt = () => {
    const concatBt = useValue.btDataType.map((item, index) => {
      switch (true) {
        case (item.key === 'projectBtV2' && item.disabled): {
          return (
            <CascaderC
              key={btV2Obj.key}
              {...props}
              label={btV2Obj.label}
              searchKey={btV2Obj.searchKey}
              options={btV2Obj.options}
            />
          )
        }
        case item.key === 'projectBt': {
          return (
            <SelectC
              key={btObj.key}
              {...props}
              label={btObj.label}
              searchKey={btObj.searchKey}
              options={btObj.options}
            />
          )
        }
      }
    })
    // 年度显示为空时，不能选择业务类型
    return <>{ concatBt.length > 0
      ? concatBt
      : <SelectC
          label='业务类型'
          modalProps={{
            disabled: true,
            placeholder: '请先选择年度'
          }}
        />
    }</>
  }

  return (
    <>
      <SelectC
       {...props}
       label='年度'
       searchKey={yearObj.searchKey}
       options={yearObj.options}
       actionChange={onYearChange}
      />
      {renderBt()}
    </>
  )
}
export default I2ProjectBtControl

I2ProjectBtControl.defaultProps = {
  propsClassName: 'mode',
  propsClassSpan: '',
  modalProps: {},
  query: {},
  options: [],
  killPending: false
}